import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Box,
  Checkbox,
  Chip,
  IconButton,
  Popover,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function BillWritableTable({ columns, rows, setRows, setTotalCount, onDeleteRow }) {
  const [infoAnchorEl, setInfoAnchorEl] = React.useState(null);
  const [infoContent, setInfoContent] = React.useState(null);

  const handleInfoOpen = (event, info) => {
    setInfoAnchorEl(event.currentTarget);
    setInfoContent(info);
  };

  const handleInfoClose = () => {
    setInfoAnchorEl(null);
    setInfoContent(null);
  };

  const handleChange = (event, row, column_id, value) => {
    console.log("rowQTY: " + row.qty);
    console.log("column_id: " + column_id);
    console.log("value: " + value);
    // Create a new array with updated row data
    const updatedRows = rows.map((currentRow, index) => {
      if (currentRow === row) {
        // Create a new object to avoid direct mutation
        const updatedRow = { ...currentRow, [column_id]: value };
        console.log("updatedRow: ", updatedRow);
        // Handle specific column logic
        if (column_id === "unitPrice" && row.qty !== 0) {
          console.log("unitPrice");
        } else if (column_id === "price" && row.qty !== 0) {
          console.log("price");
        } else if (
          column_id === "discountPerItem" &&
          row.qty !== 0 &&
          row.price !== 0
        ) {
          console.log("discountPerItem");
        }

        return updatedRow;
      }
      return currentRow;
    });

    // Update the state with the new array
    setRows(updatedRows);
  };

  const handleCheckboxChange = (event, row, column_id) => {
    console.log("Checkbox changed:", event.target.checked);
    const value = event.target.checked;
    handleChange(event, row, column_id, value);
  };

  const handleTextFieldChange = (event, row, column_id) => {
    const value = event.target.value;
    console.log("TextField changed:", value);
    handleChange(event, row, column_id, value);
  };

  return (
    <Paper elevation={3} sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, fontSize: "0.8rem" }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
                    {column.label}
                    {column.info && (
                      <Tooltip title="What does this mean?">
                        <IconButton
                          size="small"
                          sx={{ p: 0.25 }}
                          onClick={(event) => handleInfoOpen(event, column.info)}
                        >
                          <ErrorOutlineIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </TableCell>
              ))}
              {onDeleteRow && <TableCell style={{ fontSize: "0.8rem" }} />}
            </TableRow>
          </TableHead>
          <TableBody style={{ fontSize: 80 }}>
            {rows
              // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.code || index}
                  >
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ fontSize: "0.8rem", padding: "10px" }}
                        >
                          {column.editable && column.type === "checkbox" ? (
                            <Checkbox
                              size="small"
                              checked={
                                Boolean(value === "Yes") || value === true
                              }
                              onChange={(event) =>
                                handleCheckboxChange(event, row, column.id)
                              }
                              disabled={
                                column.id !== "qty" && row.qty === 0
                                  ? true
                                  : false
                              }
                              inputProps={{
                                "aria-label": `${column.id}-checkbox`,
                              }}
                              sx={{ p: 0 }} // optional: tightens spacing in the cell
                            />
                          ) : column.editable ? (
                            <TextField
                              onChange={(event) =>
                                handleTextFieldChange(event, row, column.id)
                              }
                              label={""}
                              id="outlined-size-small"
                              size="small"
                              fullWidth
                              type={column.type}
                              value={
                                column.type === "number"
                                  ? value === null || value === ""
                                    ? 0
                                    : column.isDecimal
                                    ? parseFloat(value)
                                    : Number(value)
                                  : value || ""
                              }
                              disabled={
                                column.id !== "qty" && row.qty === 0
                                  ? true
                                  : false
                              }
                              InputProps={{
                                sx: {
                                  height: 40, // controls the total input height
                                  fontSize: "0.8rem", // optional: controls text size
                                  padding: "0 10px", // optional: padding inside input
                                },
                              }}
                            />
                          ) : column.editable === false &&
                            column.format &&
                            typeof value === "number" ? (
                            column.format(value)
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                    {onDeleteRow && (
                      <TableCell align="center" style={{ padding: "4px" }}>
                        {row.fromCategoryId != null && (
                          row.pendingDeletion ? (
                            <Tooltip title="Deletion request pending approval">
                              <Chip
                                size="small"
                                label="Pending"
                                color="warning"
                                variant="outlined"
                                sx={{ fontSize: "0.65rem", height: 20 }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Remove item">
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => onDeleteRow(row)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Popover
        open={Boolean(infoAnchorEl)}
        anchorEl={infoAnchorEl}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        {infoContent && (
          <Box sx={{ p: 2, maxWidth: 380 }}>
            <Typography variant="subtitle2" gutterBottom>
              {infoContent.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {infoContent.description}
            </Typography>
            {infoContent.formula && (
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "pre-line",
                  fontFamily: "monospace",
                  fontSize: "0.75rem",
                  bgcolor: "action.hover",
                  p: 1,
                  borderRadius: 1,
                  mt: 1,
                }}
              >
                {infoContent.formula}
              </Typography>
            )}
            {infoContent.example && (
              <Typography
                variant="caption"
                display="block"
                sx={{ whiteSpace: "pre-line", mt: 1 }}
                color="text.secondary"
              >
                {infoContent.example}
              </Typography>
            )}
          </Box>
        )}
      </Popover>
    </Paper>
  );
}

export default BillWritableTable;
